'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _resource = require('../resource');

var _resource2 = _interopRequireDefault(_resource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetLists = function (_Resource) {
    (0, _inherits3.default)(TargetLists, _Resource);

    function TargetLists() {
        (0, _classCallCheck3.default)(this, TargetLists);
        return (0, _possibleConstructorReturn3.default)(this, (TargetLists.__proto__ || (0, _getPrototypeOf2.default)(TargetLists)).apply(this, arguments));
    }

    (0, _createClass3.default)(TargetLists, [{
        key: 'getAll',

        /**
         * @api {get} /v1/organization_observation_target_lists getAll
         * @apiGroup TargetLists
         * @apiName getAll
         * @apiDescription Return all target lists. This can only be invoked by the platform admin. Capable of returning paginated results.
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.targetLists.getAll({...})
         */
        value: function getAll(params) {
            var query = params ? this.stringForQueryObject(params.query) : '';

            return this.client.get('/v1/organization_observation_target_lists' + query);
        }

        /**
         * @api {get} /v1/organization_observation_target_lists/:observation_target_list_id get
         * @apiGroup TargetLists
         * @apiName get
         * @apiDescription Get organizationObservationTargetList.
         * @apiParam {Number} observation_target_list_id
         * @apiExample {js} Example:
         *             gigwalk.targetLists.get({...})
         */

    }, {
        key: 'get',
        value: function get(params) {
            return this.client.get('/v1/organization_observation_target_lists/' + params.observation_target_list_id);
        }

        /**
         * @api {get} /v1/organizations/:organization_id/target_lists getAllForOrganization
         * @apiGroup TargetLists
         * @apiName getAllForOrganization
         * @apiDescription Get all organizationObservationTargetLists in organiation. Capable of returning paginated results.
         * @apiParam {Number} organization_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.targetLists.getAllForOrganization({...})
         */

    }, {
        key: 'getAllForOrganization',
        value: function getAllForOrganization(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.get('/v1/organizations/' + params.organization_id + '/target_lists' + query);
        }

        /**
         * @api {post} /v1/organizations/:organization_id/target_lists createForOrganization
         * @apiGroup TargetLists
         * @apiName createForOrganization
         * @apiDescription Create a new orgObservationTargetList. Currently, there are no permissions checks.
         * @apiParam {Number} organization_id
         * @apiParam {Object} target_list
         * @apiExample {js} Example:
         *             gigwalk.targetLists.createForOrganization({...})
         */

    }, {
        key: 'createForOrganization',
        value: function createForOrganization(params) {
            return this.client.post('/v1/organizations/' + params.organization_id + '/target_lists', (0, _extends3.default)({}, params.target_list));
        }

        /**
         * @api {get} /v1/organizations/:organization_id/target_lists/:observation_target_list_id getForOrganization
         * @apiGroup TargetLists
         * @apiName getForOrganization
         * @apiDescription Get organizationObservationTargetList.
         * @apiParam {Number} organization_id
         * @apiParam {Number} observation_target_list_id
         * @apiExample {js} Example:
         *             gigwalk.targetLists.getForOrganization({...})
         */

    }, {
        key: 'getForOrganization',
        value: function getForOrganization(params) {
            return this.client.get('/v1/organizations/' + params.organization_id + '/target_lists/' + params.observation_target_list_id);
        }

        /**
         * @api {delete} /v1/organization_observation_target_lists/:observation_target_list_id delete
         * @apiGroup TargetLists
         * @apiName delete
         * @apiDescription Delete organizationObservationTargetListID. This is a soft delete; organizationObservationTargetList marked as DELETED.
         * @apiParam {Number} observation_target_list_id
         * @apiExample {js} Example:
         *             gigwalk.targetLists.delete({...})
         */

    }, {
        key: 'delete',
        value: function _delete(params) {
            return this.client.delete('/v1/organization_observation_target_lists/' + params.observation_target_list_id);
        }

        /**
         * @api {put} /v1/organization_observation_target_lists/:observation_target_list_id update
         * @apiGroup TargetLists
         * @apiName update
         * @apiDescription Modify the specified organizationObservationTargetList.
         * @apiParam {Number} observation_target_list_id
         * @apiParam {Object} target_list
         * @apiExample {js} Example:
         *             gigwalk.targetLists.update({...})
         */

    }, {
        key: 'update',
        value: function update(params) {
            return this.client.put('/v1/organization_observation_target_lists/' + params.observation_target_list_id, (0, _extends3.default)({}, params.target_list));
        }

        /**
         * @api {post} /v1/organization_observation_target_lists/:target_list_id/search/observation_targets searchObservationList
         * @apiGroup TargetLists
         * @apiName searchObservationList
         * @apiDescription Search all targets of an organizationObservationTargetList for the specified queryString. Capable of returning paginated results.
         * @apiParam {Number} target_list_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.targetLists.searchObservationList({...})
         */

    }, {
        key: 'searchObservationList',
        value: function searchObservationList(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.post('/v1/organization_observation_target_lists/' + params.target_list_id + '/search/observation_targets' + query);
        }

        /**
         * @api {post} /v1/target_lists/:target_list_id/search/targets searchList
         * @apiGroup TargetLists
         * @apiName searchList
         * @apiDescription Search all targets of an organizationObservationTargetList for the specified queryString. Capable of returning paginated results.
         * @apiParam {Number} target_list_id
         * @apiParam {Object} [query]
         * @apiExample {js} Example:
         *             gigwalk.targetLists.searchList({...})
         */

    }, {
        key: 'searchList',
        value: function searchList(params) {
            var query = this.stringForQueryObject(params.query);

            return this.client.post('/v1/target_lists/' + params.target_list_id + '/search/targets' + query);
        }

        /**
         * @api {get} /v1/organization_observation_target_lists/:target_list_id/observation_targets getTargets
         * @apiGroup TargetLists
         * @apiName getTargets
         * @apiDescription Return all targets of the specified organizationObservationTargetList.
         * @apiParam {Number} target_list_id
         * @apiExample {js} Example:
         *             gigwalk.targetLists.getTargets({...})
         */

    }, {
        key: 'getTargets',
        value: function getTargets(params) {
            return this.client.get('/v1/organization_observation_target_lists/' + params.target_list_id + '/observation_targets');
        }

        /**
         * @api {put} /v1/organization_observation_target_lists/:target_list_id/observation_targets updateTargets
         * @apiGroup TargetLists
         * @apiName updateTargets
         * @apiDescription ADD or REMOVE targets from the specified organizationObservationTargetList.
         * @apiParam {Number} target_list_id
         * @apiParam {String} [action='add']
         * @apiParam {Number[]} target_ids
         * @apiExample {js} Example:
         *             gigwalk.targetLists.updateTargets({...})
         */

    }, {
        key: 'updateTargets',
        value: function updateTargets(params) {
            var data = {
                action: params.action ? params.action : 'ADD',
                target_ids: params.target_ids
            };

            return this.client.put('/v1/organization_observation_target_lists/' + params.target_list_id + '/observation_targets', data);
        }

        /**
         * @api {post} /v1/target_lists/target_history searchDataItems
         * @apiGroup TargetLists
         * @apiName searchDataItems
         * @apiDescription Search all the dataItems for the specified organizationObservationID and locationID. Results sorted by dataItemTimestamp.
                           Photo dataItems will be excluded from returned data.
         * @apiParam {Number} observation_target_id
         * @apiParam {Number} location_id
         * @apiParam {Number} item_count
         * @apiExample {js} Example:
         *             gigwalk.targetLists.searchDataItems({...})
         */

    }, {
        key: 'searchDataItems',
        value: function searchDataItems(params) {
            var data = {
                observation_target_id: params.observation_target_id,
                location_id: params.location_id,
                item_count: params.item_count
            };

            return this.client.post('/v1/target_lists/target_history', data);
        }
    }]);
    return TargetLists;
}(_resource2.default);

exports.default = TargetLists;
//# sourceMappingURL=index.js.map